module.exports = __webpack_public_path__ + "media/images/sports_coaching/stella-5e9792042f6307345e2dfa432d78cdc5.jpg";